import React from 'react/addons';
import Fluxxor from 'fluxxor';
import Icon from 'ofs/components/common/Icon';

var FluxMixin = Fluxxor.FluxMixin(React);


import i18n from 'ofs/i18n';
var gettext = i18n.gettext;

import BedSizeChart from 'ofs/utils/BedSizeChart.jsx';

var messages = {
  BED_SIZE_LINK: gettext("Bed size chart"),
  BED_SIZE_HEADER: gettext("Bed size chart")
};

var BedSizeChartModal = React.createClass({
  mixins: [
    FluxMixin
  ],

  render: function() {
    return (
      <div className="bed-sizes-chart">
        <h1>{messages.BED_SIZE_HEADER}</h1>
        <div className="bed-sizes-wrap">
          <BedSizeChart />
        </div>
      </div>
    );
  }
})

var BedSizeChartLink = React.createClass({
  mixins: [
    FluxMixin
  ],

  handleModalClick: function(event) {
    this.getFlux().actions.layers.addModal(<BedSizeChartModal />);
  },

  render: function() {
    return (
      <div className="mattress-sizes">
        <Icon glyph="bedsize" size="small" />
        <a href="javascript:;" onClick={this.handleModalClick}>
          <span className="label">{messages.BED_SIZE_LINK}</span>
        </a>
      </div>
    );
  }
});

module.exports = BedSizeChartLink;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/components/bed-size-chart-link.jsx
 **/